import axios from 'axios'
import Store from '../../store'
import { errorHandler, successHandler } from '../helpers/handler'
import { BASEURL } from '../const'

const URL = `${BASEURL}/cryptocoin`

export default {
  cryptoCoin() {
    return {
      buy: async (
        coinId,
        { wallet, amount, image, paymentMethodId, networkId }
      ) => {
        const endpoint = `${URL}/${coinId}/buy`

        const formData = new FormData()

        formData.append('image', image)
        formData.append('wallet', wallet)
        formData.append('amount', amount)
        formData.append('paymentMethodId', paymentMethodId)
        if (networkId) {
          formData.append('networkId', networkId)
        }

        try {
          const res = await axios.post(endpoint, formData, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers,
              'content-type': 'multipart/form-data'
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      sell: async (coinId, { image, amount, promoCode }) => {
        const endpoint = `${URL}/${coinId}/sell`

        const formData = new FormData()
        formData.append('image', image)
        formData.append('amount', amount)
        if (promoCode) {
          formData.append('promoCode', promoCode)
        }

        try {
          const res = await axios.post(endpoint, formData, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers,
              'content-type': 'multipart/form-data'
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      getCryptosRate: async () => {
        const endpoint = `${URL}/crypto-rates`

        try {
          const res = await axios.get(endpoint, {
            params: {
              // populate: 'coinId'
            },
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      getCryptosWallets: async (params) => {
        const endpoint = `${BASEURL}/crypto-wallets`
        try {
          const res = await axios.get(endpoint, {
            params,
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })

          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      getCryptoWallet: async (walletId) => {
        const endpoint = `${BASEURL}/crypto-wallets/${walletId}`
        try {
          const res = await axios.get(endpoint, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      getCryptoWalletHistory: async (coinId, walletId, params = {}) => {
        const endpoint = `${BASEURL}/crypto-wallets/wallet-histories`
        try {
          const res = await axios.get(endpoint, {
            params: {
              coin: coinId,
              ...(walletId ? { wallet: walletId } : {}),
              orderBy: 'createdAt',
              order: 'desc',
              ...params
            },
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      getCryptosGraph: async (coinId) => {
        const endpoint = `${URL}/crypto-rates/${coinId}`
        try {
          const res = await axios.get(endpoint, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })

          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      generateCryptoAddress: async (data) => {
        const endpoint = `${BASEURL}/crypto-wallets/generate-address`
        try {
          const res = await axios.post(endpoint, data, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      sendToUser: async ({ coinId, transactions, otp }) => {
        const endpoint = `${BASEURL}/crypto-wallets/internal-transfer`
        const data = { coinId, transactions, otp }
        try {
          const res = await axios.post(endpoint, data, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      sendToWallet: async ({ coinId, network, amount, receiver, remarks, otp }) => {
        const endpoint = `${BASEURL}/crypto-wallets/external-transfer`
        const data = { coinId, network, amount, receiver, remarks, otp }
        try {
          const res = await axios.post(endpoint, data, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      getWithdrawalFee: async ({ coinId, amount, type, network }) => {
        const endpoint = `${BASEURL}/crypto-wallets/withdrawal-fee`
        const data = { coinId, amount, type, network }
        try {
          const res = await axios.post(endpoint, data, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      getSaleRate: async ({ amount, coinId }) => {
        const endpoint = `${BASEURL}/crypto-wallets/sale-rates`
        const data = { amount, coinId }
        try {
          const res = await axios.post(endpoint, data, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      refreshSaleRate: async ({ amount, coinId, quoteId }) => {
        const endpoint = `${BASEURL}/crypto-wallets/refresh-sale-rates`
        const data = { amount, coinId, quoteId }
        try {
          const res = await axios.post(endpoint, data, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      completeSaleRate: async ({ amount, coinId, quoteId }) => {
        const endpoint = `${BASEURL}/crypto-wallets/complete-sale`
        const data = { amount, coinId, quoteId }
        try {
          const res = await axios.post(endpoint, data, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      getSwapRate: async ({ amount, from, to }) => {
        const endpoint = `${BASEURL}/crypto-wallets/swap-rates`
        const data = { amount, coinId: from, destinationCoinId: to }
        try {
          const res = await axios.post(endpoint, data, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      refreshSwapRate: async ({ amount, from, to, quoteId }) => {
        const endpoint = `${BASEURL}/crypto-wallets/refresh-swap-rates`
        const data = { amount, coinId: from, destinationCoinId: to, quoteId }
        try {
          const res = await axios.post(endpoint, data, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      completeSwapRate: async ({ amount, from, to, quoteId }) => {
        const endpoint = `${BASEURL}/crypto-wallets/complete-swap`
        const data = { amount, coinId: from, destinationCoinId: to, quoteId }
        try {
          const res = await axios.post(endpoint, data, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      getPurchaseRate: async ({ amount, coinId, networkId }) => {
        const endpoint = `${BASEURL}/crypto-wallets/purchase-rates`
        const data = { amount, coinId, networkId }
        try {
          const res = await axios.post(endpoint, data, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      refreshPurchaseRate: async ({ amount, coinId, quoteId }) => {
        const endpoint = `${BASEURL}/crypto-wallets/refresh-purchase-rates`
        const data = { amount, coinId, quoteId }
        try {
          const res = await axios.post(endpoint, data, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      completePurchaseRate: async ({ amount, coinId, quoteId }) => {
        const endpoint = `${BASEURL}/crypto-wallets/complete-purchase`
        const data = { amount, coinId, quoteId }
        try {
          const res = await axios.post(endpoint, data, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      }
    }
  }
}
